export default "__VITE_ASSET__aa9d23a9__"